import React from "react";
import "../components/Blog.css";

const services = [
  {
    title: "Logo Designing",
    desc1:
      "We create unique and memorable logos that define your brand identity.",
    desc2:
      "Our designs focus on simplicity, creativity, and long-term brand recognition.",
    link: "View Samples →",
    img: "https://via.placeholder.com/500x300",
  },
  {
    title: "Graphics Designing",
    desc1:
      "We design high-quality graphics for social media, marketing, and branding.",
    desc2:
      "Our creative visuals help you attract attention and engage your audience.",
    link: "Explore Designs →",
    img: "https://via.placeholder.com/500x300",
  },
  {
    title: "Custom API Creation & Integration",
    desc1:
      "We build secure and scalable APIs tailored to your business needs.",
    desc2:
      "Seamless integration with third-party services and internal systems.",
    link: "Learn More →",
    img: "https://via.placeholder.com/500x300",
  },
  {
    title: "Software Development",
    desc1:
      "We develop custom software solutions to streamline operations.",
    desc2:
      "Scalable and future-ready enterprise solutions.",
    link: "View Solutions →",
    img: "https://via.placeholder.com/500x300",
  },
  {
    title: "Application Development",
    desc1:
      "We build high-performance mobile and web applications.",
    desc2:
      "Focused on speed, usability, and seamless experience.",
    link: "See Apps →",
    img: "https://via.placeholder.com/500x300",
  },
  {
    title: "Website Development",
    desc1:
      "We create modern, responsive, and SEO-friendly websites.",
    desc2:
      "Optimized for performance and great user experience.",
    link: "Visit Projects →",
    img: "https://via.placeholder.com/500x300",
  },
];

export default function Portfolio() {
  return (
    <>
    <section className="blog-hero">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8">
              <h1>
                Our Portfolio
              </h1>
              <h5>
                Explore our best work and successful projects
              </h5>
              <p>
                By <strong>Code Inputs</strong>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* BLOG CONTENT */}
      <section className="blog-wrapper">
        <div className="container">
        <div class="project">
          <img src="graphics/images/Artboard_1.png" width="50%" height="50%" alt="Digital Maketing"/>
          <div class="project-content">
            <h2 className="mb-2">Digital Marketing</h2><br/>
          <p>
              <b>Grow Your Business with Result-Driven Digital Marketing</b></p>

            <p>Build a stronger online presence, reach the right audience, and generate more leads with CodeInputs' professional digital marketing solutions. We combine creative content, social media marketing, SEO, and online advertising to help your business grow digitally.
          </p>
          <h6>Starting From ₹499</h6>
          <a href="https://wa.me/917693890243">Book Now -></a>
    </div>
  </div>

  { /*LOGO DESIGNING*/ }
        <div class="project">
          <img src="graphics/images/logoportfolio.png" alt="Logo Designing"/>
          <div class="project-content">
            <h2 className="mb-2">Logo Designing</h2><br/>
          <p>
              We create unique and memorable logos that define your brand identity. 
              Our designs focus on simplicity, creativity, and long-term brand recognition.
          </p>
          <p>
              From startups to established businesses, we craft logos that communicate your vision and stand out in the market.
          </p>
          <h6>Starting From ₹499</h6>
          <a href="https://wa.me/917693890243">Book Your Logo Now -></a>
    </div>
  </div>

    {/*GRAPHICS DESIGN */}
  <div class="project">
    <img src="graphics/images/graphicsdesign.png" width="80%" height="80%" alt="Graphics Designing"/>
    <div class="project-content">
      <h2>Graphics Designing</h2><br/>
      <p>
        We design high-quality graphics for social media, marketing, and branding. 
        Our creative visuals help you attract attention and engage your audience.
      </p>
      <p>
        From banners to promotional creatives, we ensure your brand looks professional across all platforms.
      </p>
      <h6>Starting From ₹99</h6>
      <a href="https://wa.me/917693890243">Book Your Design Now -></a>
    </div>
  </div>

  {/* CUSTOM API */}
  <div class="project">
    <img src="graphics/images/customapicreations.png" alt="Custom API & Integration"/>
    <div class="project-content">
      <h2>Custom API Creation & Integration</h2><br/>
      <p>
        We build secure and scalable APIs tailored to your business needs. 
        Whether it's payment gateways, third-party services, or internal systems, we ensure seamless integration.
      </p>
      <p>
        Our APIs are optimized for performance, security, and reliability.
      </p>
      <h6>Starting From ₹4999</h6>
      <a href="https://wa.me/917693890243">Reach Us →</a>
    </div>
  </div>

    {/* SOFTWARE DEVELOPMENT */}
  <div class="project">
    <img src="graphics/images/softwaredevelopment.png" alt="Software Development"/>
    <div class="project-content">
      <h2>Software Development</h2>
      <p>
        We develop custom software solutions that streamline business operations 
        and improve efficiency.
      </p>
      <p>
        From enterprise tools to automation systems, we deliver scalable and future-ready solutions.
      </p>
      <h6>Starting From ₹1999</h6>
      <a href="#">Enquire Now →</a>
    </div>
  </div>

  {/* APPLICATION DEVELOPMENT */}
  <div class="project">
    <img src="graphics/images/applicationdevelopments.png" alt="Application Development"/>
    <div class="project-content">
      <h2>Application Development</h2>
      <p>
        We build high-performance mobile and web applications with user-friendly interfaces.
      </p>
      <p>
        Our focus is on speed, usability, and delivering a seamless experience across devices.
      </p>
      <h6>Starting From ₹14999</h6>
      <a href="#">Enquire Now →</a>
    </div>
  </div>

  {/* WEBSITE DEVELOPMENT */}
  <div class="project">
    <img src="graphics/images/websitedevelopment.png" alt="Website Development"/>
    <div class="project-content">
      <h2>Website Development</h2>
      <p>
        We create modern, responsive, and SEO-friendly websites that help your business grow online.
      </p>
      <p>
        From landing pages to full-scale websites, we ensure fast performance and great design.
      </p>
      <a href="#">Enquire Now →</a>
    </div>
  </div>
  </div>
</section>
      </>
  );
}
